import { useTranslation } from 'react-i18next';
import { Box, Paper } from '@mui/material';
import MaterialButton from '@mui/material/Button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useAuth0 } from '@auth0/auth0-react';
import { colors } from '../../features/theme/settings';

interface InactivityScreenProps {
    message: string;
    showLoginButton: boolean;
}

const InactivityScreen = ({ message, showLoginButton }: InactivityScreenProps) => {
    const { t } = useTranslation();
    const { loginWithRedirect, logout } = useAuth0();
    const onLogout = () => {
        logout().then(() => {
            setTimeout(
                () =>
                    loginWithRedirect({
                        authorizationParams: {
                            redirect_uri: window.location.origin,
                        },
                    }),
                100
            );
        });
    };

    return (
        <Box
            sx={{
                backgroundColor: colors.themes.blue.primary,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
            }}
        >
            <Paper
                sx={{
                    width: '454px',
                    borderColor: colors.white,
                    borderRadius: '12px',
                    padding: '40px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                }}
            >
                <Box
                    sx={{
                        backgroundColor: colors.system.warn.bg,
                        borderRadius: '4px',
                        padding: '6px 16px 6px 16px',
                        fontSize: '14px',
                        display: 'flex',
                    }}
                >
                    <InfoOutlinedIcon
                        sx={{
                            color: colors.system.warn.main,
                            marginRight: '12px',
                        }}
                    />
                    {message}
                </Box>

                {showLoginButton && (
                    <MaterialButton
                        variant='contained'
                        size='large'
                        type='button'
                        disableRipple
                        onClick={onLogout}
                        data-testid='back-to-login'
                        sx={{
                            width: '100%',
                            height: '52px',
                            color: colors.white,
                            backgroundColor: colors.themes.blue.primary,
                            '&:hover': {
                                backgroundColor: colors.themes.blue.primary,
                            },
                        }}
                    >
                        {t('back-to-login')}
                    </MaterialButton>
                )}
            </Paper>
        </Box>
    );
};

export default InactivityScreen;
